import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { AccountMenu } from "./Component/AccountMenu";
import "../node_modules/video-react/dist/video-react.css";
import { useUser } from "./Provider/UserProvider";
import "./Component/Asset.css";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { OrganizationMemberSelectBox } from "./Component/OrganizationMemberSelectBox";
import GroupDataTable from "./Component/GroupDataTable";
import { GroupEditMode } from "./Component/GroupEditMode";
import { GroupAddMode } from "./Component/GroupAddMode";
import { Grid } from "@mui/material";
import { API_DOMAIN_URL } from "./Common";

export function EditGroup() {
  const { user } = useUser();

  //console.log(user);
  //console.log(setUser);
  const navigate = useNavigate();

  const [organizationUsers, setOrganizationUsers] = useState(null);
  const [orgUser, setOrgUser] = useState();
  useEffect(() => {
    if (orgUser && orgUser.id) {
      getOwnedGroups(orgUser);
    }
  }, [orgUser]);
  const [ownedGroups, setOwnedGroups] = useState();
  const [targetGroup, setTargetGroup] = useState();
  const [displayMode, setDisplayMode] = useState(2); // 0: 新規追加、1: 編集、削除, 2: 非表示
  const [showAddBtn, setShowAddBtn] = useState(false);

  const authCheck = () => {
    if (!user || !user.id || user.id == "error") {
      navigate("/SignIn");
      return false;
    }
    return true;
  };

  const getOrganizationUsers = () => {
    // get organization users data
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/GetOrganizationUsers?code=${code}&UserId=${user.id}`;
    //console.log(url);
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        //response.push(user);
        setOrganizationUsers(response);
      })
      .catch(() => {
        //console.error();
        console.log("EditGroup OrganizationUsers Exception");
        let orgUsers = [];
        orgUsers.push(user);
        setOrganizationUsers(orgUsers);
      });
  };

  const getOwnedGroups = (orgUser) => {
    // get organization users data
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL + `/api/GetOwnedGroups?code=${code}&UserId=${orgUser.id}`;
    //console.log(url);
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        setOwnedGroups(response);
      })
      .catch(() => {
        setOwnedGroups([orgUser]);
      });
  };

  const getGroupForSpecificMode = (val, updateGroups) => {
    if (val == 0) {
      return (
        <GroupAddMode
          orgUserId={orgUser.id}
          updateOwnedGroups={updateGroups}
          setDisplayMode={setDisplayMode}
        />
      );
    } else if (val == 1) {
      return (
        <GroupEditMode
          key={targetGroup?.id}
          group={targetGroup}
          setDisplayMode={setDisplayMode}
          updateOwnedGroups={updateGroups}
        />
      );
    } else if (val == 2) {
      return <></>;
    }
  };

  useEffect(() => {
    if (authCheck()) {
      getOrganizationUsers();
    }
  }, []);

  const clickedEvent = () => {
    console.log("start add mode");
    setDisplayMode(0);
  };

  // 組織内のメンバー群を更新する
  const updateOwnedGroups = () => {
    getOwnedGroups(orgUser);
  };

  return (
    <div className="asset-list-root">
      <AccountMenu />
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item md={4}>
              <Typography component="h1" variant="h5">
                グループ編集
              </Typography>
            </Grid>
            <Grid item md={8}></Grid>

            <Grid item md={3} mt={1}>
              <OrganizationMemberSelectBox
                orgUsers={organizationUsers}
                setOrgUser={setOrgUser}
                setShowAddBtn={setShowAddBtn}
              />
            </Grid>
            <Grid item md={9} mt={1}></Grid>
          </Grid>

          <Grid container justify="flex-end" mb={1}>
            {showAddBtn == true ? (
              <>
                <Button
                  variant="contained"
                  color="success"
                  sx={{ mt: 2 }}
                  align
                  onClick={clickedEvent}
                >
                  新規追加
                </Button>
              </>
            ) : (
              ""
            )}
          </Grid>
          <GroupDataTable
            ownedGroups={ownedGroups}
            setDisplayMode={setDisplayMode}
            setTargetGroup={setTargetGroup}
          />
          <Box sx={{ mb: 4 }} />

          {getGroupForSpecificMode(displayMode, updateOwnedGroups)}
        </Box>
      </Container>
    </div>
  );
}
